var _desc, _defs, _rect, _circle, _circle2, _path, _path2, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuroraMigrationFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 720",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "RDS\uC5D0\uC11C Aurora\uB85C \uC804\uD658\uD558\uB294 \uB370\uC774\uD130\uBCA0\uC774\uC2A4 \uB9C8\uC774\uADF8\uB808\uC774\uC158 \uD750\uB984") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "\uAE30\uC874 RDS\uC758 \uBCC0\uACBD \uB370\uC774\uD130\uB97C CDC\uB85C \uBCF5\uC81C\uD574 Writer\uC640 Reader \uAD6C\uC870\uC758 Aurora\uB85C \uC804\uD658\uD558\uB294 \uC138 \uB2E8\uACC4 \uD750\uB984")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10Z",
    fill: "#43a9df"
  })), /*#__PURE__*/React.createElement("style", null, "\n      text { font-family: Pretendard, \"Apple SD Gothic Neo\", \"Noto Sans KR\", sans-serif; }\n      .label { fill: #26384b; font-size: 42px; font-weight: 800; letter-spacing: -0.5px; }\n      .label-accent { fill: #1377ad; font-size: 42px; font-weight: 800; letter-spacing: -0.5px; }\n      .caption { fill: #748396; font-size: 26px; font-weight: 650; }\n      .caption-accent { fill: #3689b5; font-size: 26px; font-weight: 700; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    rx: 38,
    fill: "#fbfcfd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 360,
    r: 285,
    fill: "none",
    stroke: "#eef2f5",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 360,
    r: 210,
    fill: "none",
    stroke: "#f3f6f8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 332 H472",
    fill: "none",
    stroke: "#c9d5de",
    strokeWidth: 6,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M728 332 H880",
    fill: "none",
    stroke: "#8bcbed",
    strokeWidth: 6,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 270,
    rx: 92,
    ry: 30,
    fill: "#e7ecf1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 270 V390 C108 407 149 420 200 420 C251 420 292 407 292 390 V270",
    fill: "#f2f5f7",
    stroke: "#d4dde5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 270,
    rx: 92,
    ry: 30,
    fill: "#f7f9fa",
    stroke: "#d4dde5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 330 C108 347 149 360 200 360 C251 360 292 347 292 330",
    fill: "none",
    stroke: "#dce4ea",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 500,
    textAnchor: "middle",
    className: "label"
  }, "\uAE30\uC874 RDS"), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 546,
    textAnchor: "middle",
    className: "caption"
  }, "\uB2E8\uC77C DB"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 332,
    r: 112,
    fill: "#ffffff",
    stroke: "#b9def1",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 332,
    r: 12,
    fill: "#a7d7ef"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 332,
    r: 12,
    fill: "#69bce6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648,
    cy: 332,
    r: 12,
    fill: "#2f9bd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541 300 C570 269 630 269 659 300",
    fill: "none",
    stroke: "#cfe8f5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541 364 C570 395 630 395 659 364",
    fill: "none",
    stroke: "#cfe8f5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 500,
    textAnchor: "middle",
    className: "label"
  }, "CDC \uBCF5\uC81C"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 546,
    textAnchor: "middle",
    className: "caption"
  }, "Binlog \uAE30\uC900"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 332,
    r: 116,
    fill: "#e8f6fd",
    stroke: "#8ccfee",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 312,
    r: 48,
    fill: "#ffffff",
    stroke: "#56b2df",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 284,
    r: 38,
    fill: "#ffffff",
    stroke: "#8ccfee",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1046,
    cy: 370,
    r: 42,
    fill: "#ffffff",
    stroke: "#8ccfee",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 312 L1002 312 M982 329 L1010 355 M1025 321 L1033 332",
    stroke: "#56b2df",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1000,
    y: 500,
    textAnchor: "middle",
    className: "label-accent"
  }, "Aurora"), /*#__PURE__*/React.createElement("text", {
    x: 1000,
    y: 546,
    textAnchor: "middle",
    className: "caption-accent"
  }, "Writer \xB7 Reader"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuroraMigrationFlow);
export default __webpack_public_path__ + "static/media/aurora-migration-flow.6c0a1ff0e40675f8345c9ae80a61dd8e.svg";
export { ForwardRef as ReactComponent };